import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faInstagram, faYoutube } from "@fortawesome/free-brands-svg-icons";
import "./Footer.css";

const Footer = () => {
    const currentYear = new Date().getFullYear();

    const footerLinks = {
        Contact: ["3201 W. Peoria Ave. Ste #C500, Phoenix, AZ 85029", "(623) 773-2000", "join@stampmedical.com"],
        Resources: ["Why Stamp Medical?", "Join Now", "www.stampmedical.com"],
    };

    const socialLinks = [
        { name: "Facebook", icon: faFacebook, url: "https://facebook.com/stampmedical" },
        { name: "Instagram", icon: faInstagram, url: "https://instagram.com/stampmedical" },
        { name: "YouTube", icon: faYoutube, url: "https://www.youtube.com/@CHIROFITPhoenix" },
    ];

    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-brand">
                        <h3>Stamp Medical</h3>
                        <p>Connecting healthcare providers with Personal Injury patients nationwide. Join our growing network of medical professionals.</p>
                        <div className="social-links">
                            {socialLinks.map((social, index) => (
                                <a
                                    key={index}
                                    href={social.url}
                                    className="social-link"
                                    aria-label={social.name}
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    <FontAwesomeIcon
                                        icon={social.icon}
                                        className="social-icon"
                                        style={{ color: "white", fontSize: "20px" }}
                                    />
                                </a>
                            ))}
                        </div>
                    </div>

                    <div className="footer-links">
                        {Object.entries(footerLinks).map(([category, links]) => (
                            <div
                                key={category}
                                className="footer-column">
                                <h4>{category}</h4>
                                <ul>
                                    {links.map((link, index) => (
                                        <li key={index}>{link === "(623) 773-2000" ? <a href="tel:+16237732000">{link}</a> : link === "join@stampmedical.com" ? <a href="mailto:join@stampmedical.com">{link}</a> : <a href={link === "Why Stamp Medical?" ? "#features" : link === "www.stampmedical.com" ? "https://www.stampmedical.com" : "#contact"}>{link}</a>}</li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="footer-bottom">
                    <div className="footer-bottom-content">
                        <p>&copy; {currentYear} Stamp Medical. All rights reserved.</p>
                        <div className="footer-legal">
                            <a
                                href="https://stampmedical.com/privacy"
                                target="_blank"
                                rel="noopener noreferrer">
                                Privacy Policy
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
